module.exports = __webpack_public_path__ + "img/kr-product-final-card1-img2.54ab8d7.png";